const navigation = {
  nav: {
    home: "Αρχική",
    about: "Σχετικά με Εμάς",
    services: "Υπηρεσίες",
    testimonials: "Ευχαριστημένοι Ασθενείς",
    gallery: "Φωτογραφίες",
    contact: "Επικοινωνία",
  },
  servicesMenu: {
    trigger: "Υπηρεσίες",
    allServices: "Προβολή Όλων των Υπηρεσιών",
  },
  serviceLinks: {
    implantology: {
      name: "Εμφυτευματολογία",
      description: "Υψηλής ποιότητας, μακροχρόνιες αντικαταστάσεις δοντιών",
    },
    endodontics: {
      name: "Ενδοδοντία",
      description: "Προηγμένες θεραπείες ριζικού καναλιού",
    },
    "oral-surgery": {
      name: "Στοματοχειρουργική",
      description: "Ακριβείς στοματοχειρουργικές διαδικασίες",
    },
    periodontology: {
      name: "Περιοδοντία",
      description: "Εξειδικευμένες θεραπείες και φροντίδα ούλων",
    },
    orthodontics: {
      name: "Ορθοδοντία",
      description: "Εξειδικευμένες θεραπείες για στραβισμένα δόντια",
    },
    bonding: {
      name: "Κολλητική",
      description: "Κοσμητικές επισκευές με ρητίνη χρώματος δοντιού",
    },
    prosthetics: {
      name: "Προσθετική",
      description: "Εξατομικευμένες γέφυρες και οδοντοστοιχίες",
    },
    cariesology: {
      name: "Καριολογία",
      description: "Πρόληψη και θεραπεία της τερηδόνας",
    },
    "teeth-whitening": {
      name: "Λεύκανση Δοντιών",
      description: "Επαγγελματική λεύκανση δοντιών για ένα πιο λαμπερό χαμόγελο",
    },
    "dental-tourism": {
      name: "Οδοντιατρικός Τουρισμός",
      description: "Ολοκληρωμένα πακέτα οδοντιατρικής φροντίδας για διεθνείς ασθενείς",
    },
    prices: {
      name: "Τιμές",
      description: "Ενημερωμένος τιμοκατάλογος ανά υπηρεσία",
    },
  },
};

export default navigation;
